import { useNavigate, useStore, usePathValidation } from '~hooks'
import { RadioList } from '~components'
import { Values } from './interfaces'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { string, object } from '~utils/validation'
import * as Styled from './styled'
import mobile from 'is-mobile'
import { useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'

function VehicleBody() {
  const navigate = useNavigate()
  const { register: storeRegister, vehicle, update } = useStore()
  const openVehicles = vehicle?.bodies?.data?.filter?.((item) => item.type === 'aberta')
  const closedVehicles = vehicle?.bodies?.data?.filter?.((item) => item.type === 'fechada')
  const specialVehicles = vehicle?.bodies?.data?.filter?.((item) => item.type === 'especial')
  const isMobile = mobile()
  const schema = object().shape({
    vehicleBody: string().required(),
  })
  const defaultValues = { vehicleBody: storeRegister?.vehicleBody }
  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    track('cadastro_tipo_carroceria', { tipo_veiculo: storeRegister.vehicleType })
  }, [])

  useEffect(() => {
    update({ register: { progress: 50 } })
  }, [update])
  usePathValidation([
    'cpf',
    'plate',
    'register.cellphone',
    'register.fullName',
    'register.rntrc',
    'register.vehicleType',
  ])

  function onSubmit(values: Values) {
    update({ register: values })
    navigate('/cadastrar/rastreador-veiculo', { state: { previousPath: '/cadastrar/tipo-carroceria' } })
  }

  return (
    <Styled.Form
      onSubmit={handleSubmit(onSubmit)}
      aria-labelledby="form-truck-body-title"
    >
      <Styled.Title id="form-truck-body-title">
        Selecione o tipo de carroceria
      </Styled.Title>
      <Styled.Row>
        <RadioList
          list={openVehicles}
          name="vehicleBody"
          title="Abertas"
          register={register}
        />
        <RadioList
          list={closedVehicles}
          name="vehicleBody"
          title="Fechadas"
          register={register}
        />
        <RadioList
          list={specialVehicles}
          name="vehicleBody"
          title="Especiais"
          register={register}
          isValid={isValid}
        />
      </Styled.Row>
      {(!isMobile || isValid) && (
        <Styled.Footer>
          <Styled.Button width="350px" disabled={!isValid}>
            Continuar
          </Styled.Button>
        </Styled.Footer>
      )}
    </Styled.Form>
  )
}

export default VehicleBody
